<template>
  <b-overlay
    id="overlay-background"
    :show="loader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  ><b-alert
     v-height-fade.appear
     :show="dismissCountDown"
     dismissible
     fade
     variant="warning"
     class="mb-0"
     @dismiss-count-down="countDownChanged"
   >
     <div class="alert-body">
       <span>{{ $t('DEBTIA_PAYMENT_SETTING_ERROR_MSG') }}</span>
     </div>
   </b-alert>
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <validation-observer
              ref="infoRules"
              tag="form"
            >
              <b-form>
                <b-row>
                  <b-col sm="12">

                    <validation-provider
                      #default="{ errors }"
                      name="First Account Type"
                      rules="required"
                    >
                      <b-form-group
                        label="First Account Type"
                        label-for="first_account_type"
                      >
                        <b-form-input
                          id="mail-from-address"
                          v-model="accountType1"
                          type="text"
                          placeholder="First Account Type"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      #default="{ errors }"
                      name="First Account Number"
                      rules="required"
                    >
                      <b-form-group
                        label="First Account Number"
                        label-for="first_account_number"
                      >
                        <b-form-input
                          id="mail-from-address"
                          v-model="accountNr1"
                          type="text"
                          placeholder="First Account Number"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      #default="{ errors }"
                      name="Second Account Type"
                      rules="required"
                    >
                      <b-form-group
                        label="Second Account Type"
                        label-for="second_account_type"
                      >
                        <b-form-input
                          id="mail-from-address"
                          v-model="accountType2"
                          type="text"
                          placeholder="Second Account Type"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      #default="{ errors }"
                      name="Second Account Number"
                      rules="required"
                    >
                      <b-form-group
                        label="Second Account Number"
                        label-for="second_account_number"
                      >
                        <b-form-input
                          id="mail-from-address"
                          v-model="accountNr2"
                          type="text"
                          placeholder="Second Account Number"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  block
                  variant="primary"
                  @click="postSettingValues"
                >
                  Save
                </b-button>
              </b-form>
            </validation-observer>
            <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay, BFormInput, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { heightFade } from '@core/directives/animations'
import axios from '@axios'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    BOverlay,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BAlert,
  },
  directives: {
    Ripple,
    heightFade,
  },
  props: {
  },
  data() {
    return {
      loader: false,
      accountType1: null,
      accountNr1: null,
      accountType2: null,
      accountNr2: null,
      required,
      dismissCountDown: 0,
      dismissSecs: 5,
    }
  },
  watch: {
  },
  created() {
    this.getData()
  },
  methods: {
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    async getData() {
      this.loader = true
      await axios.get('/payment/account/get?type=Undefined').then(response => {
        if (response.status) {
          this.accountNr1 = response.data.data.account_number_1
          this.accountNr2 = response.data.data.account_number_2
          this.accountType1 = response.data.data.account_type_1
          this.accountType2 = response.data.data.account_type_2
          this.loader = false
        }
      }).catch(() => {
        this.loader = false
        this.showAlert()
      })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.currencySettingLoader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    postSettingValues() {
      this.$refs.infoRules.validate().then(success => {
        if (success) {
          this.loader = true
          const obj = {
            account_type_1: this.accountType1,
            account_number_1: this.accountNr1,
            account_type_2: this.accountType2,
            account_number_2: this.accountNr2,
            type: 'Undefined',
          }
          axios.post('payment/account/save', obj).then(response => {
            if (response.status) {
              this.loader = false
              this.makeSuccessToast()
            }
          }).catch(error => {
            this.loader = false
            this.makeFailureToast(error)
          })
        }
      })
    },
  },
}
</script>

    <style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .fields-container {
      border: 2px solid #f8f8f8;
      border-radius: 10px;
    }
    </style>
